import { useEffect } from "react";

/**
 * Adds .in-view to any element with .fade-up when it scrolls into the viewport.
 */
export default function useInView() {
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-up");
        if (!("IntersectionObserver" in window)) {
            elements.forEach((el) => el.classList.add("in-view"));
            return;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 },
        );
        elements.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);
}
